import React from "react";
import InitDashboard from "./component/sections/InitDashboard";

function App() {
  return (
    <>
      <InitDashboard />
    </>
  );
}

export default App;
